import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class BeginGameOverlay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.isActive = false;

    this.getReadyText = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._GetReady, this).setOrigin(0);
    this.getReadyText.x = this.scene.scale.width / 2 - this.getReadyText.getBounds().width / 2;

    this.arrowUp = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._Arrow, this).setOrigin(0);
    this.arrowUp.x = this.scene.scale.width / 2 - this.arrowUp.getBounds().width / 2;
    this.arrowUp.alpha = 0;

    if (!ABCyaLib.DEVICE_INFO.desktop) {
      this.deviceItem = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._ShowTap, this).setOrigin(0);

      this.helperHand = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._InstructTap, this).setOrigin(0);
      this.helperHand.x = this.scene.scale.width / 2 - this.helperHand.getBounds().width / 2;

      this.clickyClick = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._TapClick, this).setOrigin(0);
      this.clickyClick.x = this.helperHand.x + 98;
    }
    else {
      this.deviceItem = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._ShowClick, this).setOrigin(0);

      this.helperHand = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._InstructClick, this).setOrigin(0);
      this.helperHand.x = this.scene.scale.width / 2 - this.helperHand.getBounds().width / 2;

      this.clickyClick = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._ClickClick, this).setOrigin(0);
      this.clickyClick.x = this.helperHand.x + 86;
    }

    this.deviceItem.x = this.scene.scale.width / 2 - this.deviceItem.getBounds().width / 2;
    this.helperHand.alpha = 0;
    this.helperHand.x = this.scene.scale.width / 2 - this.helperHand.getBounds().width / 2;
    this.clickyClick.alpha = 0;

    this.layoutRatio();
  }

  activate() {
    this.isActive = true;
    this.clickyClick.alpha = 0;
    this.arrowUp.alpha = 0;
    this.helperHand.alpha = 0;
    this.deviceItem.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.deviceItem, 200, { alpha: 1 }, Phaser.Math.Easing.Linear);

    this.layoutRatio();

    this.waitTween = this.scene.time.delayedCall(1300, () => { this.fakeClick1(); });
  };

  deactivate() {
    this.isActive = false;

    if (this.waitTween) {
      this.waitTween.paused = true;
      this.waitTween.remove();
      this.waitTween.destroy();
      this.waitTween = null;
    }

    this.scene.tweens.killTweensOf(this);
  };

  fakeClick1() {
    this.scene.fakeClick();

    ABCyaPhaser.Tweens.addTween(this.clickyClick, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this.clickyClick, 110, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    });

    ABCyaPhaser.Tweens.addTween(this.helperHand, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this.helperHand, 110, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    });

    if (this.isActive) this.waitTween = this.scene.time.delayedCall(420, () => { this.fakeClick2(); });
  };

  fakeClick2() {
    this.scene.fakeClick();

    ABCyaPhaser.Tweens.addTween(this.clickyClick, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this.clickyClick, 80, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    });

    ABCyaPhaser.Tweens.addTween(this.helperHand, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this.helperHand, 80, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    });

    ABCyaPhaser.Tweens.addTween(this.arrowUp, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this.arrowUp, 210, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    });

    this.arrowUp.y = this.scene.santa.pos.y + 18;

    if (this.isActive) this.waitTween = this.scene.time.delayedCall(420, () => { this.fakeClick3(); });
  };

  fakeClick3() {
    this.scene.fakeClick();

    ABCyaPhaser.Tweens.addTween(this.clickyClick, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this.clickyClick, 80, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    });

    ABCyaPhaser.Tweens.addTween(this.helperHand, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this.helperHand, 80, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    });

    ABCyaPhaser.Tweens.addTween(this.arrowUp, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this.arrowUp, 210, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    });

    this.arrowUp.y = this.scene.santa.pos.y + 18;

    if (this.isActive) this.waitTween = this.scene.time.delayedCall(2500, () => { this.fakeClick1(); });
  };

  layoutRatio() {
    this.getReadyText.y = this.scene.scale.height / 2 - 240;
    this.helperHand.y = this.scene.scale.height / 2 + 88;
    this.deviceItem.y = this.helperHand.y;
    this.clickyClick.y = this.helperHand.y - 20;
  };
}